module.exports = __webpack_public_path__ + "static/media/jeep_ad.b903847a.jpeg";